import Table from './components/table/index'

const components = [
    Table
]

const install = function(Vue) {
    components.map(component => {
        Vue.component(component.name, component)
    })
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}

export default {
    install,
    Table
}


// WEBPACK FOOTER //
// ./src/index.js